import { styled, theme } from "../../../../styles/stitches.config"

export const SPriceInfoContainer = styled("div", {
  "@md": {
    paddingRight: theme.space.s4,
    width: theme.sizes.s56,
  },

  variants: {
    popOut: {
      true: {
        paddingRight: theme.space.s4,
        backgroundColor: theme.colors.white,
        borderRadius: theme.radii.default,

        paddingTop: theme.space.s4,
        paddingLeft: theme.space.s4,
        paddingBottom: theme.space.s4,

        boxShadow: theme.shadows.default,

        "@md": {
          borderRadius: theme.sizes.s40,
        },
      },
      false: {},
    },
  },

  defaultVariants: {
    popOut: false,
  },
})

export const SPriceInfoContent = styled("div", {
  display: "flex",
  gap: theme.space.s6,
  alignItems: "center",
  flexDirection: "column",

  "@md": {
    flexDirection: "row",
  },

  variants: {
    padded: {
      true: {
        "@md": {
          paddingLeft: theme.space.s4,
        },
      },
      false: {},
    },
  },

  defaultVariants: {
    padded: true,
  },
})

export const SPricePointsContainer = styled("div", {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-evenly",
  gap: theme.space.s4,
  flexShrink: 0,
})
